var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10.5,
    viewBox: "0 0 11 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendarIcon",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2839",
    "data-name": "Rectangle 2839",
    width: 10,
    height: 9,
    transform: "translate(0 1)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_430",
    "data-name": "Line 430",
    y2: 2.485,
    transform: "translate(7.034)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_431",
    "data-name": "Line 431",
    y2: 2.485,
    transform: "translate(2.659)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2840",
    "data-name": "Rectangle 2840",
    width: 1.491,
    height: 1.491,
    transform: "translate(5.542 4.225)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2841",
    "data-name": "Rectangle 2841",
    width: 1.491,
    height: 1.491,
    transform: "translate(2.659 4.225)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2842",
    "data-name": "Rectangle 2842",
    width: 1.491,
    height: 1.491,
    transform: "translate(5.542 6.959)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2843",
    "data-name": "Rectangle 2843",
    width: 1.491,
    height: 1.491,
    transform: "translate(2.659 6.959)",
    fill: "var(--mainColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.5ac8e082a80441f241457221a9e7c574.svg";
export { ForwardRef as ReactComponent };